'use strict';

module.exports = require('./makeMakeHot');


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-hot-api/modules/index.js
 ** module id = 77
 ** module chunks = 0
 **/